import { createCommand } from 'lexical'

export const START_FORMAT_PAINT_COMMAND = createCommand<void>(
  'START_FORMAT_PAINT_COMMAND'
)

export const DONE_FORMAT_PAINT_COMMAND = createCommand<void>()

export const CANCEL_FORMAT_PAINT_COMMAND = createCommand<void>(
  'CANCEL_FORMAT_PAINT_COMMAND'
)
